<template>
  <div class="missions-cards">
    <div class="missions-cards4">
      <div class="mission">
        <div class="mission-title">Communication</div>
      </div>

      <div class="mission">
        <div class="mission-title">Interface amont aval</div>
      </div>

      <div class="mission">
        <div class="mission-title">Permanence téléphonique</div>
      </div>

      <div class="mission">
        <div class="mission-title">Accompagnement des opérateurs</div>
      </div>

      <div class="mission">
        <div class="mission-title">
          Interface pouvoirs publics et professionnels
        </div>
      </div>

      <div class="mission">
        <div class="mission-title">
          Information, conseils, mises en contact, échanges
        </div>
      </div>

      <div class="mission">
        <div class="mission-title">
          Règlementation de la filière BIO au niveau national
        </div>
      </div>

      <div class="mission">
        <div class="mission-title">
          Rédaction et évolution des textes réglementaires
        </div>
      </div>
  </div>
  <div class="missions-cards2">
      <div class="mission">
        <div class="mission-title">
          Prospection de nouveaux contacts, site Internet, salons, relations presse générale et spécialisée, promotion de l'Agriculture Biologique, études prospectives
        </div>
      </div>

      <div class="mission">
        <div class="mission-title">
          Échanges permanents entre les pouvoirs publics, les offices, les interprofessions, les organismes professionnels du secteur amont et du secteur aval de la filière bio
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: "MissionsCards",
};
</script>

<style>
.missions-cards {
  display: grid;
  gap: 8px 8px;
}
  .missions-cards4, .missions-cards2 {
  align-items: flex-start;
  display: grid;
  /* display: flex; */
  grid-template-columns: repeat(4, 1fr);
  /* grid-template-rows: repeat(3, 1fr); */
  flex-wrap: wrap;
  gap: 8px 8px;
  /* left: 597px; */
  /* position: absolute; */
  /* top: 1141px; */
  width: 48vw;
}
.missions-cards2 {
  grid-template-columns: repeat(2, 1fr);
}
.missions-cards4 .mission,
.missions-cards2 .mission {
  align-items: center;
  justify-content: center;
  background-color: #f6f5e1c7;
  border-radius: 12px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  overflow: hidden;
  padding: 16px 12px;
  /* position: relative; */
  width: fit-content;
  width: -webkit-fill-available;
  height: -webkit-fill-available;
}

.missions-cards4 .mission-title ,
.missions-cards2 .mission-title {
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;
  /* margin-top: -1.00px; */
  /* position: relative; */
  /* white-space: nowrap; */
}
@media (max-width:1200px){
  .missions-cards4, .missions-cards2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: -webkit-fill-available;
  }
}
</style>